import { buildAppUrl } from "../../../common/appUrl";

export const buildCoachingArtifactUrl = (artifactId: string): string =>
  buildAppUrl(`/coaching/${artifactId}`);
